module.exports = __webpack_public_path__ + "media/images/flags/32/Egypt-9b93633049a1cf64a6c200fef36f77d0.png";